import { useSyncExternalStore } from "react";

let mode: "all" | "practice" = "all";
const subs = new Set<() => void>();

export const setCurrentMode = (m: "all" | "practice") => {
  mode = m;
  subs.forEach(f => f());
};
const getMode = () => mode;
const sub = (f: () => void) => { subs.add(f); return () => subs.delete(f); };

export const useMode = () => useSyncExternalStore(sub, getMode);